export const iconFontAwesomeDesignEyeSlash = (
	<i className="fa-solid fa-eye-slash"></i>
);
